var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1 6.5a1 1 0 0 0 0 2zm16.707 1.707a1 1 0 0 0 0-1.414L11.343.429A1 1 0 1 0 9.93 1.843L15.586 7.5l-5.657 5.657a1 1 0 0 0 1.414 1.414zM1 8.5h16v-2H1z"
})));
export default SvgArrowRight;